<script lang="ts">
	import StarIcon from "@lucide/svelte/icons/star";
	import * as Card from "#lib/web-ui/ui/card//index.js";
	import * as Carousel from "#lib/web-ui/ui/carousel//index.js";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import { GoogleSVG } from "#lib/web-ui/svg/index.js";
	import { getTemplateContext } from "../template-context.svelte";
	import { onMount } from "svelte";

	const templateContext = getTemplateContext();

	let carouselReady = $state(false);

	onMount(() => {
		window.requestAnimationFrame(() => {
			carouselReady = true;
		});
	});
</script>

<Section class="bg-border/40">
	{#if carouselReady}
		<Carousel.Root
			opts={{
				align: "start"
			}}
			class="w-full"
		>
			<Carousel.Content>
				{#each templateContext.testimonials as testimonial}
					<Carousel.Item class="md:basis-1/2 lg:basis-1/3">
						<div class="h-full p-1">
							<Card.Root
								class="bg-foreground/90 h-full shadow-md transition-shadow duration-300 hover:shadow-lg"
							>
								<Card.Content class="flex h-full flex-col p-6">
									<!-- 										<div class="mb-4 flex items-center">
											<GoogleSVG />
										</div> -->

									<div class="mb-4 flex-shrink-0">
										<span class="text-lg font-semibold text-white">
											{testimonial.name}
										</span>

										<div class="mt-1 mb-2 flex items-center">
											{#each Array(testimonial.rating) as _}
												<StarIcon
													class="text-primary h-4 w-4 fill-current"
												/>
											{/each}
										</div>

										<span class="text-sm text-neutral-300"
											>{testimonial.date}</span
										>
									</div>
									<div class="flex-grow leading-relaxed text-white">
										<p>{testimonial.content}</p>
									</div>
								</Card.Content>
							</Card.Root>
						</div>
					</Carousel.Item>
				{/each}
			</Carousel.Content>
			<Carousel.Previous />
			<Carousel.Next />
		</Carousel.Root>
	{/if}
</Section>
